<template>
  <div :class="wrapperClass">
    <section class="desc">
      <h2 class="title">
        Feedback from the Workera community
      </h2>
    </section>
    <img />
    <div v-if="$mq === 'desktop'" class="cards">
      <hooper
        ref="carousel"
        :shortDrag="false"
        :wheelControl="false"
        :touchControl="false"
        :progress="false"
        :itemsToShow="3"
        :infiniteScroll="false"
        :settings="hooperSettings"
        style="height: auto"
      >
        <slide
          v-for="featureCard in featureCards"
          :class="description"
          :key="featureCard.id"
        >
          <FeatureCardNew
            :id="featureCard.id"
            :title="featureCard.title"
            :descriptions="featureCard.descriptions"
            :link="featureCard.link"
            :footer="featureCard.footer"
          />
        </slide>
      </hooper>
    </div>
    <div v-else>
      <FeatureCardNew
        v-for="featureCard in featureCards"
        :key="featureCard.id"
        :id="featureCard.id"
        :title="featureCard.title"
        :descriptions="featureCard.descriptions"
        :link="featureCard.link"
        :footer="featureCard.footer"
        style="margin: 1rem"
      />
    </div>
  </div>
</template>

<script>
// In your Vue.js component.
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import "hooper/dist/hooper.css";

import "vueperslides/dist/vueperslides.css";
import FeatureCardNew from "~/components/global/FeatureCardNew";

export default {
  components: {
    Hooper,
    Slide,
    HooperPagination,
    FeatureCardNew
  },
  data() {
    return {
      hooperSettings: {
        // mobile
        itemsToShow: 1,
        breakpoints: {
          600: {
            // tablet
            itemsToShow: 2
          },
          992: {
            // laptop/desktop
            itemsToShow: 3
          }
        }
      },
      featureCards: [
        {
          id: "landing-page/why-workera/land-a-job",
          title: "",
          descriptions: [
            " “I love that I can take technical assessments to learn what skills to improve. Workera not only provided me with personalized feedback based on the assessment results, but also a learning curriculum to reach my target role.”"
          ],
          link: "",
          footer: {
            image: require("~/assets/img/landing-page/feedback/paige.png"),
            name: "Paige Chang",
            profession: "PhD Student at University of Pennsylvania"
          }
        },
        {
          id: "landing-page/why-workera/know-where-you-stand",
          title: "",
          descriptions: [
            " “Anyone who is interested in AI will find tremendous resources on Workera. Their innovative skills assessment helped me evaluate myself as an ML practitioner. I really wish a platform like this existed when I was beginning my journey in AI but Im grateful it exists now.”"
          ],
          link: "",
          footer: {
            image: require("~/assets/img/landing-page/feedback/emmanuel.png"),
            name: "Emmanuel Acheampong",
            profession: "Machine Learning Engineer"
          }
        },
        {
          id: "landing-page/why-workera/practice-makes-perfect",
          title: "",
          descriptions: [
            " “The quality and breadth of the questions asked on Workera were in a league of its own. Add to that, the option to know where you stand and the credibility of the people behind the platform, and you have a game changer. I got a clear understanding of where I stand in a variety of quintessential fields relevant to the AI field.”"
          ],
          link: "",
          footer: {
            image: require("~/assets/img/landing-page/feedback/aditya.png"),
            name: "Aditya Lahiri",
            profession: "Research Engineer at American Express, AI Labs"
          }
        }
      ]
    };
  },
  computed: {
    title() {
      switch (this.$mq) {
        case "desktop":
          return "title";
        default:
          return "title-mobile";
      }
    },
    wrapperClass() {
      switch (this.$mq) {
        case "desktop":
          return "wrapper";
        case "tablet":
          return "wrapper tablet";
        default:
          return "wrapper mobile";
      }
    },
    description() {
      switch (this.$mq) {
        case "desktop":
          return "descrpt";
        default:
          return "description-mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 4rem 1.5rem;
  .title {
    font-weight: 800;
    font-size: 36px;
    line-height: 36px;
    letter-spacing: -1px;
  }

  &.mobile {
    padding: 1rem 1.5rem;

    .title {
      font-weight: 800;
      font-size: 32px;
      line-height: 32px;
      letter-spacing: -1px;
    }
  }

  .cards {
    .feature-card-wrapper-mobile {
      display: flex;
      justify-content: center;

      .feature-card {
        margin: auto;
      }
    }
  }
}
</style>

<style lang="scss"></style>
